import {
    CallDataModel,
    CallEventModel,
    CallStatus,
    CallTranscriptModel,
    CallType,
    FullAudit,
    CallSummaryModel,
    CallTagModel,
    CallUraModel,
    ConnectFlowSurveyModel,
    ContactModel,
    LevelModel,
    UserModel,
    ConnectFlowSurveyQuestionAnswerModel,
    CallSpeechMetricsModel,
} from '@/types';

export interface CallModel extends FullAudit {
    id: number;
    level: LevelModel;
    environmentId: string;
    type: CallType;
    startedAt: Date;
    endedAt?: Date;
    answeredAt?: Date;
    sourceNumber: string;
    sourceUserId?: string;
    sourceExtensionNumber?: string;
    destinationUser?: UserModel;
    destinationNumber: string;
    destinationUserId?: string;
    destinationExtensionNumber?: string;
    media?: string;
    adId?: string;
    keyword?: string;
    audioFilePath?: string;
    externalId?: string;
    duration: number;
    billSec?: number;
    geolocation?: string;
    status: CallStatus;
    survey: ConnectFlowSurveyModel;
    surveyAnswers?: ConnectFlowSurveyQuestionAnswerModel[];
    ura: CallUraModel[];
    isFirstContact: boolean;
    transcripts?: CallTranscriptModel[];
    tags: CallTagModel[];
    events: CallEventModel[];
    data: CallDataModel;
    contact: ContactModel;
    speechMetrics?: CallSpeechMetricsModel | null;
    summary?: CallSummaryModel;
}
